import { useCallback, useContext } from 'react';

import { Context } from '../contexts/AppContext';
import { gaEvent } from '../utils/ga';

export default function useGa(...args) {
  const { user } = useContext(Context);

  return useCallback(() => {
    gaEvent({
      ...args,
      ...(user && { user_id: user.id }),
    });
  }, [args, user]);
}
